//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'operationBoard',
  data(){
    return {
      period:'today',
      loading:false,
      errorText:'',
      requestId:0,
      summary:{by_type:{},sources:{}},
      periods:[
        {key:'today',label:'今日'},
        {key:'yesterday',label:'昨日'},
        {key:'week',label:'本周'},
        {key:'month',label:'本月'},
        {key:'year',label:'本年'}
      ],
      cardTypes:[
        {key:'package',label:'次卡',color:'#2d7ff9'},
        {key:'stored',label:'储值',color:'#16b5a0'},
        {key:'discount',label:'折扣卡',color:'#e8b04b'},
        {key:'year',label:'年卡',color:'#8b5cf6'}
      ]
    }
  },
  computed:{
    sourceList(){
      var sources=this.summary.sources || {};
      return ['mini','offline','douyin'].map(function(key){
        var item=sources[key] || {};
        return {key:key,label:item.label || ({mini:'小程序',offline:'线下',douyin:'抖音'}[key]),amount:Number(item.amount)||0,percent:Number(item.percent)||0};
      });
    }
  },
  created(){
    var requested=String(this.$route.query.period || 'today');
    if(this.periods.some(item=>item.key === requested)) this.period=requested;
    this.loadSummary();
  },
  methods:{
    changePeriod(period){
      if(this.period === period || this.loading) return;
      this.period=period;
      this.$router.replace({name:'operationBoard',query:{period:period}});
      this.loadSummary();
    },
    loadSummary(){
      var current=++this.requestId;
      this.loading=true;
      this.errorText='';
      this.$api.operationBoardSummary({period:this.period}).then((res)=>{
        if(current !== this.requestId) return;
        this.loading=false;
        if(res && res.data){
          this.summary=res.data;
          return;
        }
        this.errorText='经营数据加载失败';
      }).catch(()=>{
        if(current !== this.requestId) return;
        this.loading=false;
        this.errorText='经营数据加载失败，请稍后重试';
      });
    },
    openDetail(dimension){
      this.$router.push({name:'operationBoardDetail',query:{period:this.period,dimension:dimension}});
    },
    typeAmount(key){ return this.summary.by_type && this.summary.by_type[key] || 0; },
    money(value){
      var number=Number(value)||0;
      return number.toLocaleString('zh-CN',{minimumFractionDigits:0,maximumFractionDigits:2});
    },
    count(value){ return (Number(value)||0).toLocaleString('zh-CN'); },
    percent(value){
      var number=Number(value)||0;
      return (number % 1 === 0 ? number.toFixed(0) : number.toFixed(1)) + '%';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/operationBoard.vue